//@flow
import * as React from 'react';

type EventType =
    | 'onClick'
    | 'onContextMenu'
    | 'onDoubleClick'
    | 'onDrag'
    | 'onDragEnd'
    | 'onDragEnter'
    | 'onDragExit'
    | 'onDragLeave'
    | 'onDragOver'
    | 'onDragStart'
    | 'onDrop'
    | 'onMouseDown'
    | 'onMouseEnter'
    | 'onMouseLeave'
    | 'onMouseMove'
    | 'onMouseOut'
    | 'onMouseOver'
    | 'onMouseUp';

type Props = {
    children: React.Node,
    eventTypes: EventType | Array<EventType>
};

const StopPropagation = (props: Props) => {
    const { children, eventTypes = [] } = props;
    const componentProps = {};

    const handleStopPropagation = event => {
        event.stopPropagation();
    };

    if (typeof eventTypes === 'string') {
        componentProps[eventTypes] = handleStopPropagation;
    } else {
        eventTypes.forEach(eventType => {
            componentProps[eventType] = handleStopPropagation;
        });
    }
    return <div {...componentProps}>{children}</div>;
};

export default StopPropagation;
